import IgtSettings from '@/modules/integrations/types/igt/IgtSettings'
import IgtOverview from '@/modules/integrations/types/igt/IgtOverview'

export default Object.freeze({
  type: 'igt',
  title: 'Integrations_Igt',
  category: 'Integrations_Igt_Category',
  description: 'Integrations_Igt_Description',
  image: require('@/img/integrations/igt-brightstar.svg'),
  requiresAdmin: false,
  requiresApproval: true,
  components: {
    settings: IgtSettings,
    overview: IgtOverview
  },
  urls: {
    guide: 'https://docs.xtremepush.com/docs/brightstar-lottery-pam'
  }
})



// WEBPACK FOOTER //
// ./src/modules/integrations/types/igt/index.js